module.exports = __webpack_public_path__ + "img/idea-hatchery-wordmark.78728a29.png";